/**
 * Native HTML datetime-local input wrapped with PrimeReact styling, exposing an onChange
 * prop that receives `{ value }` matching other HiVolution form inputs.
 *
 * @component
 * @param {Object} props
 * @param {Boolean} [props.required] - Whether the input is required.
 * @param {Boolean} [props.disabled] - Whether the input is disabled.
 * @param {String} [props.value] - Current datetime value (ISO datetime string).
 * @param {String} [props.min] - Minimum selectable datetime.
 * @param {String} [props.max] - Maximum selectable datetime.
 * @param {Number} [props.step] - Granularity (in seconds) of the datetime input.
 * @param {Function} props.onChange - Called with `{ value }` when the datetime changes.
 * @returns {React.JSX.Element}
 */
export default function DatetimeInput(props) {
  /**
   * Forwards the native input's change event to `props.onChange` as `{ value }`.
   *
   * @param {Event} e - Native change event from the input.
   * @returns {void}
   */
  const onChange = e => {
    props.onChange({ value: e.target.value })
  }
  return (
    <input
      required={props.required}
      disabled={props.disabled}
      className="p-inputtext p-component"
      type="datetime-local"
      value={props.value}
      onChange={onChange}
      onFocus={e => e.target.showPicker()}
      min={props.min}
      max={props.max}
      step={props.step}
    />
  )
}

DatetimeInput.displayName = 'DatetimeInput'
